export default function Gallery() {
  const images = [
    {
      src: "https://static.readdy.ai/image/3ac88beca320db2f961147cc19b75475/2acb1866a4ce05d905016e7a91bec011.png",
      alt: "Afiche oficial Baños Run 2026",
    },
    {
      src: "https://static.readdy.ai/image/3ac88beca320db2f961147cc19b75475/e89f44aa2a02ceea3caa33f1d9d60e7c.png",
      alt: "Medalla conmemorativa Baños Run 2026",
    },
    {
      src: "https://static.readdy.ai/image/3ac88beca320db2f961147cc19b75475/da0b73f8bfd9ca071a6137b40e40a3b3.png",
      alt: "Camiseta oficial del corredor",
    },
    {
      src: "https://static.readdy.ai/image/3ac88beca320db2f961147cc19b75475/c966e299d7275505654852a65f959d1a.png",
      alt: "Logo oficial Baños Run 2026",
    },
  ];

  return (
    <section className="w-full bg-secondary-900 rounded-2xl md:rounded-3xl mx-2 md:mx-4 lg:mx-8 py-6 md:py-8 px-4 md:px-6">
      <div className="flex gap-3 md:gap-4 overflow-x-auto pb-2 snap-x snap-mandatory">
        {images.map((img, idx) => (
          <div
            key={idx}
            className="flex-shrink-0 w-64 md:w-72 lg:w-80 snap-start"
          >
            <div className="relative rounded-xl overflow-hidden aspect-[4/3] bg-white">
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                <p className="text-white text-xs font-semibold">{img.alt}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}